import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { isXeroEnabled } from '@/lib/feature-flags';
import { DataSheet } from '@/components/tracking/DataSheet';
import { FinanceGuard } from '@/components/finance/FinanceGuard';

/**
 * /finance/data — the F-124 data sheet (the granular bottom layer). "Drill to
 * Source" links land here with ?focus=<metric id> to scroll that row into view.
 * Flag-gated like the rest of the finance surfaces.
 */
const searchSchema = z.object({
  /** Metric/row id to scroll into focus (from "Drill to Source"). */
  focus: z.string().optional(),
});

function DataPage() {
  const { focus } = Route.useSearch();
  return (
    <FinanceGuard>
      <DataSheet focusId={focus} />
    </FinanceGuard>
  );
}

export const Route = createFileRoute('/finance/data')({
  beforeLoad: () => {
    if (!isXeroEnabled()) {
      throw redirect({ to: '/finance', replace: true });
    }
  },
  component: DataPage,
  validateSearch: searchSchema,
});
